import React, { useEffect, useState } from "react";
import Map, { enShowMap } from "./Map";
import { Button } from "@mui/material";
import ButtonAvr, { BadSmell, Minwon, enShowValue } from "./ButtonAvr";

function Main(props) {
  const [hide, setHide] = useState("false");
  const [showAirValue, setShowAirValue] = useState(props.enShowAir.ShowStink);
  const [showValue, setShowValue] = useState(enShowValue.ShowDilution);
  const [modalOpen, setModalOpen] = useState(false);
  const [seqNo, setSeqNo] = useState(0);
  const [name, setName] = useState("");
  const [textToggle, setTextToggle] = useState(false);
  const [showMapValue, setShowMapValue] = useState(enShowMap.ShowMidnight);

  const stinkToggle = () => {
    setTextToggle(!textToggle);
  };

  const onClick = (value) => {
    setHide(value);
  };

  const AirOrSmell = () => {
    if (hide === "true")
      return <ButtonAvr showValue={showValue} setShowValue={setShowValue} />;
    else if (hide === "false")
      return <BadSmell showValue={showValue} setShowValue={setShowValue} />;
    else if (hide === "norm")
      return (
        <Minwon
          showValue={showValue}
          setShowValue={setShowValue}
          modalOpen={modalOpen}
          ass={() => setModalOpen(false)}
          seqNo={seqNo}
        />
      );
  };

  useEffect(() => {
    setName("초미세먼지");
  }, []);

  return (
    <div className="main">
      <Map
        hide={hide}
        key={hide}
        name={name}
        showValue={showValue}
        hole={() => setModalOpen(true)}
        setSeqNo={(abc) => setSeqNo(abc)}
        textToggle={textToggle}
        stinkToggle={stinkToggle}
        showMapValue={showMapValue}
        setShowMapValue={setShowMapValue}
      />
      <AirOrSmell />
      <div className="air_stink">
        <Button
          className={
            showAirValue === props.enShowAir.ShowStink ? "show" : " basic"
          }
          onClick={() => {
            onClick("false");
            setShowAirValue(props.enShowAir.ShowStink);
          }}
        >
          악취
        </Button>
        <Button
          className={
            showAirValue === props.enShowAir.ShowMinwon ? "show" : " basic"
          }
          onClick={() => {
            onClick("norm");
            setShowAirValue(props.enShowAir.ShowMinwon);
          }}
        >
          민원
        </Button>
        {/* <Button className={showAirValue === enShowAir.ShowAir ? "show" : " basic"}
                    onClick={() => {
                        onClick('true')
                        setShowAirValue(enShowAir.ShowAir);
                    }}>대기</Button> */}
      </div>
      <div className="toggle">
        <Button
          className="basic"
          onClick={hide === "false" ? stinkToggle : null}
          style={{
            display: hide === "false" ? "inline-block" : "none",
          }}
        >
          {textToggle ? "측정소명 숨기기" : "측정소명 보이기"}
        </Button>
      </div>
    </div>
  );
}

export default Main;
